import { useRef } from "react";
import { LayerVisual } from "@/components/layers";

const CORNERS = [
  { k: "nw", cls: "-left-1.5 -top-1.5 cursor-nwse-resize", fx: -1, fy: -1 },
  { k: "ne", cls: "-right-1.5 -top-1.5 cursor-nesw-resize", fx: 1, fy: -1 },
  { k: "sw", cls: "-left-1.5 -bottom-1.5 cursor-nesw-resize", fx: -1, fy: 1 },
  { k: "se", cls: "-right-1.5 -bottom-1.5 cursor-nwse-resize", fx: 1, fy: 1 },
];
const clamp = (v, a, b) => Math.min(b, Math.max(a, v));

export const LayerBox = ({ layer, selected, pageRef, onSelect, onChange, z }) => {
  const start = useRef(null);

  const begin = (e, mode) => {
    e.stopPropagation();
    onSelect(layer.id);
    if (layer.locked) return;
    const rect = pageRef.current.getBoundingClientRect();
    start.current = { mode, px: e.clientX, py: e.clientY, rect, l: { x: layer.x, y: layer.y, w: layer.w, h: layer.h } };
    e.currentTarget.setPointerCapture(e.pointerId);
  };

  const move = (e) => {
    const s = start.current;
    if (!s) return;
    const dx = ((e.clientX - s.px) / s.rect.width) * 100;
    const dy = ((e.clientY - s.py) / s.rect.height) * 100;
    const { l } = s;
    if (s.mode === "move") {
      onChange(layer.id, { x: +clamp(l.x + dx, 0, 100 - l.w).toFixed(2), y: +clamp(l.y + dy, 0, 100 - l.h).toFixed(2) });
      return;
    }
    const c = CORNERS.find((k) => k.k === s.mode);
    let { x, y, w, h } = l;
    if (c.fx > 0) w = clamp(l.w + dx, 2, 100 - l.x);
    else { w = clamp(l.w - dx, 2, l.x + l.w); x = l.x + l.w - w; }
    if (c.fy > 0) h = clamp(l.h + dy, 2, 100 - l.y);
    else { h = clamp(l.h - dy, 2, l.y + l.h); y = l.y + l.h - h; }
    onChange(layer.id, { x: +x.toFixed(2), y: +y.toFixed(2), w: +w.toFixed(2), h: +h.toFixed(2) });
  };

  const end = () => { start.current = null; };

  if (layer.hidden) return null;
  return (
    <div
      data-testid={`canvas-layer-${layer.id}`}
      onPointerDown={(e) => begin(e, "move")}
      onPointerMove={move}
      onPointerUp={end}
      className={`absolute touch-none select-none ${layer.locked ? "cursor-not-allowed" : "cursor-move"} ${selected ? "outline outline-2 outline-[#3D3DF0]" : "hover:outline hover:outline-1 hover:outline-[#3D3DF0]/60"}`}
      style={{ left: `${layer.x}%`, top: `${layer.y}%`, width: `${layer.w}%`, height: `${layer.h}%`, zIndex: z }}
    >
      <div className={`pointer-events-none h-full w-full ${layer.style === "invisible" ? "bg-[#A62B8A]/15 outline-dashed outline-1 outline-[#A62B8A]" : ""}`}>
        <LayerVisual layer={layer} />
      </div>
      {selected && !layer.locked && CORNERS.map((c) => (
        <span key={c.k} onPointerDown={(e) => begin(e, c.k)} onPointerMove={move} onPointerUp={end} className={`absolute h-3 w-3 rounded-sm border border-white bg-[#3D3DF0] text-white ${c.cls}`} data-testid={`resize-${c.k}-${layer.id}`} />
      ))}
      {selected && (
        <span className="pointer-events-none absolute -top-6 left-0 whitespace-nowrap rounded bg-[#3D3DF0] text-white px-1.5 py-0.5 font-mono text-[10px]">{layer.name}</span>
      )}
    </div>
  );
};
